<template>
  <div class="changeCourses">
    换课申请页面
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>